import React from "react";
import Button from "./Button";
import { Link } from "react-router-dom";
import {
  REACT_APP_ASSETS_URL,
  REACT_APP_MAIANS_TWITTER_URL,
} from "constants/constant";
import Common from "common/common.helpers";
import { useState } from "react";
import { toast } from "react-toastify";
import { set } from "firebase/database";
const validateEmail = (email) => {
  return /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);
};

export default function Footer() {
  const [emailaddress, setEmailaddress] = useState("");
  const [message, setMessage] = useState("");
  const handleEmailSubmit = async (e) => {
    let isvalid = validateEmail(emailaddress);
    if (isvalid) {
      try {
        const isEmailExists = await Common.getSingleDocument(
          "newsletter",
          emailaddress
        );
        if (isEmailExists?.email) {
          setMessage("Already exist");
        } else {
          await Common.setDocument("newsletter", emailaddress, {
            email: emailaddress,
          });
          setMessage("Success");
          setEmailaddress("");
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setMessage("Error");
      setEmailaddress("");
    }
  };

  return (
    <footer className="relative overflow-hidden">
      <div className="wrapper relative flex flex-col gap-6 lg:gap-8">
        <div className="footer-top relative z-10 max-w-[1800px] mx-auto px-4 w-full flex flex-col justify-center text-center md:flex-row md:items-end md:justify-between gap-4 pt-[80px] lg:pt-[93px]">
          <div className="relative flex flex-col gap-6 md:gap-6">
            <div className="flex flex-col gap-4 md:gap-6 text-center md:text-start">
              <img
                src={`${REACT_APP_ASSETS_URL}footer-logo.svg`}
                alt=""
                className="w-[42px] h-[42px] lg:w-[46px] lg:h-[46px] mx-auto md:mx-0 flex items-center justify-center"
              />
              <p className="text-xsm md:text-sm">Copyright © 2024 Maian</p>
            </div>

            <div className="relative mx-auto md:hidden">
              <svg
                width="217"
                height="1"
                viewBox="0 0 217 1"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  y1="0.5"
                  x2="217"
                  y2="0.5"
                  stroke="url(#paint0_radial_4285_1281)"
                />
                <defs>
                  <radialGradient
                    id="paint0_radial_4285_1281"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(109 4.5) rotate(-142.306) scale(55.6058 45.2199)"
                  >
                    <stop stopColor="white" stopOpacity="0.51" />
                    <stop offset="0.805118" stopColor="white" stopOpacity="0" />
                  </radialGradient>
                </defs>
              </svg>
            </div>

            <div className="relative w-full flex items-center justify-between md:justify-start gap-0 lg:gap-4">
              <div className="relative inline-flex items-center justify-end w-[49%] md:justify-center h-[48px] md:h-[61px] md:w-fit">
                <svg
                  width="160"
                  height="61"
                  viewBox="0 0 160 61"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-fit md:w-auto"
                >
                  <g filter="url(#filter0_i_4356_1368)">
                    <rect
                      width="160"
                      height="61"
                      rx="30.5"
                      fill="#03D9AF"
                      fillOpacity="0.06"
                    />
                    <rect
                      x="0.439655"
                      y="0.439655"
                      width="159.121"
                      height="60.1207"
                      rx="30.0603"
                      stroke="url(#paint0_radial_4356_1368)"
                      strokeWidth="0.87931"
                    />
                    <path
                      d="M34.7466 47L38.4951 40.4971L27.2495 21H19.7485L16 27.499H23.5049L34.7466 47ZM42.2476 33.998L46 27.499L42.2476 21H34.7505L31.002 27.499H38.499L42.2476 33.998Z"
                      fill="#03D9AF"
                    />
                    <path
                      d="M38.4951 27.499L42.2476 21L34.7466 21L30.998 27.499H38.4951Z"
                      fill="#03D9AF"
                    />
                    <path
                      d="M23.4971 27.499L27.2495 21H19.7485L16 27.499L23.4971 27.499Z"
                      fill="#03D9AF"
                    />
                    <path
                      opacity="0.64"
                      d="M57.311 27V17.34H60.8438C62.5964 17.34 63.866 18.4854 63.866 20.238C63.866 21.9768 62.5412 23.205 60.8438 23.205H58.4288V27H57.311ZM58.4288 22.1838H60.7472C61.9064 22.1838 62.7206 21.3558 62.7206 20.238C62.7206 19.134 61.9064 18.3474 60.7472 18.3474H58.4288V22.1838ZM68.2949 27.1794C66.1697 27.1794 64.6379 25.6614 64.6379 23.481C64.6379 21.3144 66.1697 19.7826 68.2949 19.7826C70.4201 19.7826 71.9519 21.3144 71.9519 23.481C71.9519 25.6614 70.4201 27.1794 68.2949 27.1794ZM65.7695 23.481C65.7695 25.068 66.8183 26.1858 68.2949 26.1858C69.7715 26.1858 70.8203 25.068 70.8203 23.481C70.8203 21.9354 69.7715 20.7762 68.2949 20.7762C66.8183 20.7762 65.7695 21.9354 65.7695 23.481ZM74.6478 27L72.8538 19.962H74.0268L75.6276 26.7792L77.187 19.962H79.2432L80.8164 26.7792L82.4448 19.962H83.5902L81.7824 27H79.7814L78.2358 20.1828L76.6488 27H74.6478ZM87.9941 27.1794C85.8689 27.1794 84.4889 25.5924 84.4889 23.412C84.4889 21.1626 86.1035 19.7826 87.9803 19.7826C90.1055 19.7826 91.2923 21.3972 91.2923 23.343C91.2923 23.5224 91.2785 23.7018 91.2647 23.826H85.5929C85.7309 25.2336 86.6141 26.1858 87.9941 26.1858C88.9601 26.1858 89.7329 25.7994 90.2159 24.999L91.0439 25.5234C90.5057 26.517 89.3879 27.1794 87.9941 27.1794ZM85.6067 22.86H90.2159C90.2159 21.687 89.2499 20.7486 87.9803 20.7486C86.6141 20.7486 85.7999 21.687 85.6067 22.86ZM92.9517 27V19.962H94.0419V22.7772C94.0419 21.1488 94.9803 19.893 96.6777 19.893V21.0798H96.5259C94.8009 21.0798 94.0557 22.239 94.0557 23.5776V27H92.9517ZM101.012 27.1794C98.8873 27.1794 97.5073 25.5924 97.5073 23.412C97.5073 21.1626 99.1219 19.7826 100.999 19.7826C103.124 19.7826 104.311 21.3972 104.311 23.343C104.311 23.5224 104.297 23.7018 104.283 23.826H98.6113C98.7493 25.2336 99.6325 26.1858 101.012 26.1858C101.978 26.1858 102.751 25.7994 103.234 24.999L104.062 25.5234C103.524 26.517 102.406 27.1794 101.012 27.1794ZM98.6251 22.86H103.234C103.234 21.687 102.268 20.7486 100.999 20.7486C99.6325 20.7486 98.8183 21.687 98.6251 22.86ZM108.675 27.1794C106.867 27.1794 105.418 25.62 105.418 23.4948C105.418 21.3558 106.826 19.7826 108.675 19.7826C110.165 19.7826 111.173 20.7762 111.393 22.3356V17.34H112.497V27H111.393V24.516C111.173 25.9098 110.455 27.1794 108.675 27.1794ZM106.55 23.4948C106.55 25.1508 107.598 26.1858 109.006 26.1858C110.496 26.1858 111.435 24.9714 111.435 23.4948C111.435 21.7422 110.331 20.7762 108.978 20.7762C107.598 20.7762 106.55 21.8802 106.55 23.4948ZM122.382 27.1794C120.643 27.1794 119.801 25.9098 119.58 24.516V27H118.476V17.34H119.58V22.3356C119.801 20.7762 120.946 19.7826 122.382 19.7826C124.231 19.7826 125.556 21.3558 125.556 23.4948C125.556 25.62 124.189 27.1794 122.382 27.1794ZM119.539 23.4948C119.539 24.9714 120.477 26.1858 121.968 26.1858C123.375 26.1858 124.424 25.1508 124.424 23.4948C124.424 21.8802 123.375 20.7762 121.995 20.7762C120.643 20.7762 119.539 21.7422 119.539 23.4948ZM128.855 27L126.315 19.962H127.53L129.903 26.7792L132.401 19.962H133.643L129.848 29.898H128.675L129.821 27H128.855Z"
                      fill="white"
                    />
                    <path
                      d="M64.928 47.234C64.154 47.234 63.578 46.946 63.182 46.37L56.18 36.218L59.114 34.652L64.802 42.788C64.838 42.842 64.874 42.878 64.928 42.878C64.964 42.878 65.018 42.86 65.054 42.788L70.724 34.652L73.658 36.218L66.656 46.37C66.26 46.946 65.684 47.234 64.928 47.234ZM86.9437 47.27L85.3417 45.038H76.2157L74.6137 47.27L71.6797 45.704L79.0417 35.552C79.4557 34.976 80.0317 34.688 80.7877 34.688C81.5077 34.688 82.0837 34.976 82.5157 35.552L89.8777 45.704L86.9437 47.27ZM78.2137 42.284H83.3617L80.9137 38.882C80.8597 38.828 80.8237 38.792 80.7877 38.792C80.7517 38.792 80.6977 38.828 80.6617 38.882L78.2137 42.284ZM104.615 47.198C103.985 47.198 103.409 46.982 102.887 46.532L94.7326 39.62C94.6606 39.584 94.6066 39.566 94.5706 39.584C94.5346 39.62 94.5166 39.656 94.5166 39.728V47H91.1506V37.226C91.1506 36.326 91.3126 35.696 91.6366 35.336C91.9606 34.976 92.4106 34.796 92.9686 34.796C93.5806 34.796 94.1566 35.03 94.6966 35.462L102.851 42.356C102.905 42.41 102.959 42.428 102.995 42.392C103.031 42.374 103.067 42.32 103.067 42.248V34.958H106.433V44.768C106.433 45.686 106.253 46.316 105.929 46.676C105.605 47.036 105.155 47.198 104.615 47.198ZM123.322 47.27L121.72 45.038H112.594L110.992 47.27L108.058 45.704L115.42 35.552C115.834 34.976 116.41 34.688 117.166 34.688C117.886 34.688 118.462 34.976 118.894 35.552L126.256 45.704L123.322 47.27ZM114.592 42.284H119.74L117.292 38.882C117.238 38.828 117.202 38.792 117.166 38.792C117.13 38.792 117.076 38.828 117.04 38.882L114.592 42.284ZM142.559 45.74L139.679 47.54L136.007 43.436H130.949V47.018H127.529V37.676C127.529 36.812 127.745 36.128 128.213 35.66C128.681 35.192 129.347 34.958 130.229 34.958H137.627C139.355 34.958 140.597 35.3 141.353 35.984C142.109 36.668 142.505 37.748 142.505 39.188C142.505 41.312 141.641 42.626 139.931 43.166L142.559 45.74ZM130.949 38.468V40.358H137.843C138.275 40.358 138.599 40.304 138.797 40.178C138.977 40.052 139.085 39.764 139.085 39.332C139.085 38.9 138.977 38.63 138.779 38.486C138.581 38.36 138.275 38.288 137.843 38.288H131.129C131.003 38.288 130.949 38.36 130.949 38.468Z"
                      fill="white"
                    />
                  </g>
                  <defs>
                    <filter
                      id="filter0_i_4356_1368"
                      x="0"
                      y="0"
                      width="160"
                      height="64"
                      filterUnits="userSpaceOnUse"
                      colorInterpolationFilters="sRGB"
                    >
                      <feFlood floodOpacity="0" result="BackgroundImageFix" />
                      <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                      />
                      <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                      />
                      <feOffset dy="3" />
                      <feGaussianBlur stdDeviation="5" />
                      <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                      />
                      <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0.313726 0 0 0 0 0.74902 0 0 0 0 0.643137 0 0 0 0.3 0"
                      />
                      <feBlend
                        mode="normal"
                        in2="shape"
                        result="effect1_innerShadow_4356_1368"
                      />
                    </filter>
                    <radialGradient
                      id="paint0_radial_4356_1368"
                      cx="0"
                      cy="0"
                      r="1"
                      gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(80 30.5) rotate(-76.054) scale(31.4263 84.9926)"
                    >
                      <stop offset="0.48202" stopColor="#03D9AF" />
                      <stop
                        offset="0.828515"
                        stopColor="#03D9AF"
                        stopOpacity="0"
                      />
                    </radialGradient>
                  </defs>
                </svg>
              </div>

              <Link
                to={`${REACT_APP_MAIANS_TWITTER_URL}`}
                target="_blank"
                className="inline-flex items-center justify-start w-[49%] md:justify-center md:w-fit"
              >
                <Button
                  className="outline-button twitter p-4 lg:p-[20px] h-[48px] md:h-[61px] text-white border-0"
                  text="Join Us on"
                  twitterIcon
                />
              </Link>
            </div>
          </div>

          <div className="flex flex-col gap-4 text-center md:text-start">
            <p className="text-sm lg:text-base font-serif">
              Join Our Community
            </p>
            <div className="relative flex flex-col max-w-[350px] mx-auto md:mx-0">
              <div className="relative flex items-center justify-between h-[48px] md:h-[61px] mb-8">
                <input
                  type="email"
                  placeholder="Enter Email to join"
                  className="font-sans pr-[50px] md:pr-[60px] h-[50px] md:h-[60px] border-[1.5px] rounded-full md:min-w-[200px] lg:min-w-[312px]"
                  onChange={(e) => setEmailaddress(e.target.value)}
                  value={emailaddress}
                />
                <Button
                  className="primary-button absolute right-[5px] w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full"
                  iconButton
                  onClickHandler={handleEmailSubmit}
                />
              </div>
              <div className="absolute bottom-0 left-1/2 -translate-x-1/2 md:left-0 md:translate-x-0 w-full">
                {message === "Error" && (
                  <p className="text-sm font-serif text-error">
                    Please enter a valid email.
                  </p>
                )}

                {message === "Already exist" && (
                  <p className="text-sm font-serif text-lime">
                    Email registered already
                  </p>
                )}

                {message === "Success" && (
                  <p className="text-sm font-serif text-lime">
                    Thank you!
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom max-w-[1800px] xl:min-h-[300px] mx-auto px-4 w-full relative flex items-end">
          <img
            src={`${REACT_APP_ASSETS_URL}footer-maians.svg`}
            alt=""
            className="max-h-full max-w-full lg:mt-[-50px]"
          />
        </div>
      </div>
    </footer>
  );
}
